import { IMatchChangeLmpTemplate } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLmpMatchChange } from './typeguards';
import { CreateLmpMatchChangeInputSchema, LmpMatchChangeMatchInput } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { LmpMatchChangeQuery } from '../types';
import { intcmpMap } from '../../../utils/intcmp';

export default (obj: LmpMatchChangeQuery): IMatchChangeLmpTemplate => {
  if (isValidLmpMatchChange(obj)) {
    CreateLmpMatchChangeInputSchema().parse(obj.data.getLmpMatchChange, {reportInput: true});

    const {  matchId, matchList } = obj.data.getLmpMatchChange;
     
      return {
        matchId,
        matchList: matchList!.map((match) => {
          const { away, home, status, id, link } = match as LmpMatchChangeMatchInput;
          return {
            away,
            home,
            id,
            link,
            status,
          };
        }),
        trackingData: intcmpMap.matchChangeLmp,
      } as IMatchChangeLmpTemplate;

  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LmpMatchChangeQuery object',
      data: obj
    });
  }
};
